
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';


import { Link } from "react-router-dom";
import spanyol from "../../assets/spanyol.png";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"

function SpanyolMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Spanyol magyar fordító</title>
                <meta name='description' content="Ingyenes spanyol magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Spanyol magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/spanyol-magyar-fordito" />
            </Helmet>
            <h1>Spanyol magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A Spanyol nyelvről</h2>
                    <img src={spanyol} alt="Spanyol zászló"></img>
                </div>

                <p>A spanyol egy neo-latin nyelv, amelyet körülbelül 460 millió ember beszél világszerte. Ez a második legszélesebb körben beszélt nyelv világszerte, és az Egyesült Nemzetek Szervezetének hat hivatalos nyelvének egyike. A spanyol szépségéről, dallamos hangzásáról és gazdag kulturális örökségéről ismert Spanyolországban és Latin-Amerikában.</p>

                <p>Írásrendszer a latin ábécét használja, amely 27 betűből áll. A spanyol kiejtése általában fonetikus, a helyesírás és a hang között szoros összefüggés van. Minden betűnek konzisztens hangja van, így viszonylag egyszerű a spanyol szavak kiejtése.</p>

                <p>Nyelvtana főnévi és melléknévi megegyezést tartalmaz a nemben és a számban, az igék ragozásában és a nyelvtani névelőkben. A főneveket hímnemű és nőnemű nemekre osztják, és a mellékneveknek meg kell egyezniük velük. Az igék ragozása idő, mód, aspektus és személy szerint történik.</p>

                <p>Szókincse latin gyökerű, és más nyelvekből származó kölcsönszavakat is tartalmaz, különösen az arab, az angol és az amerikai kontinensen őshonos nyelveket. A spanyolnak gazdag irodalmi hagyománya van, olyan befolyásos szerzőkkel, mint Miguel de Cervantes, Gabriel García Márquez és Jorge Luis Borges. A spanyol nyelvű országok jelentős mértékben hozzájárultak a művészethez, a zenéhez, a tánchoz és a mozihoz.</p>

                <p>A spanyol kultúra sokszínű, tükrözve az egyes spanyol nyelvű országok egyedi jellemzőit. A spanyol nyelv tanulása betekintést nyújt a spanyol nyelvű közösségek történelmébe, szokásaiba és értékeibe. Lehetővé teszi a spanyol hagyományok, ünnepségek és társadalmi normák mélyebb megértését.</p>

                <p>A spanyol nyelvtudás számos lehetőség előtt nyit ajtót. A spanyol 21 ország hivatalos nyelve, köztük Spanyolország, Mexikó, Argentína és Kolumbia. Megkönnyíti az utazást, a kommunikációt és a kulturális elmélyülést a spanyol nyelvű régiókban. A spanyol az üzleti életben, a turizmusban, a fordításban, az oktatásban és a nemzetközi kapcsolatokban is értékes eszköz.</p>
           
           
                <div className="sectionbottom">
                    <Link to="/magyar-spanyol-fordito">Magyar spanyol fordító</Link>

                    <img src={spanyol} alt="spanyol zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>
           
            </section>
        </>

    )
}

export default SpanyolMagyar;